import MenuEdit from "../../components/MenuEdit/MenuEdit"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function EditMenu() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn]);
  
  return (
    <div className="px-8 pt-14 m-auto">
      <MenuEdit />
    </div>
  );
}

export default EditMenu;
